import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { memo } from "react";
import cx from "classnames";
import { TabList as ReactTabList } from "react-tabs";
import PropTypes from "prop-types";
import styles from "./TabList.module.css";

const TabList = _ref => {
  let {
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ReactTabList, _extends({
    className: cx(styles.tabList, className)
  }, props));
};

TabList.defaultProps = {
  className: ""
};
TabList.propTypes = {
  className: PropTypes.string
};

const _default = Object.assign( /*#__PURE__*/memo(TabList), {
  tabsRole: "TabList",
  displayName: "TabList"
});

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabList, "TabList", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Tabs/TabList/TabList.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Tabs/TabList/TabList.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();